<template>
  <v-layout
    wrap
  >
    <v-flex
      v-for="(card, i) in [1,2,3,4]"
      v-show="$apollo.loading"
      :key="i"
      md6
      xs12
    >
      <v-card>
        <v-skeleton-loader
          type="list-item-avatar"
          :tile="false"
          class="mx-auto"
          width="100%"
          height="75"
        />
      </v-card>
    </v-flex>

    <v-flex
      v-for="(item, o) in portfolioDetails.data"
      v-show="!$apollo.loading && portfolioDetails"
      :key="o+10"
      md6
      xs12
    >
      <v-card>
        <v-card-title>{{ $t('dashboard.currentBalance') }} ({{ item.base_currency }})</v-card-title>
        <v-layout
          wrap
          class="mt-3 mb-3"
        >
          <v-flex
            main-text
            xs12
            pl-5
            pt-0
            pb-3
          >
            <span class="text-no-wrap">
              {{ item.base_currency | renderSymbol }} 
              {{ item.current_balance | formatMoney }}
            </span>
          </v-flex>
          <v-flex
            xs12
            pt-0
            pb-1
          >
            <v-chip
              color="info text-black"
              small
            >
              {{ item.base_currency | renderSymbol }}
              {{ item.deposited_funds | formatMoney }} {{ $t('dashboard.deposited') }}
            </v-chip>
          </v-flex>
          <v-flex
            pt-0
            pb-0
          >
            <v-chip
              color="info text-black"
              small
            >
              {{ item.base_currency | renderSymbol }}
              {{ item.withdrawed_funds | formatMoney }}  {{ $t('dashboard.withdrawed') }}
            </v-chip>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex
      v-if="!$apollo.loading && portfolioDetails"
      md6
      xs12
    >
      <v-card>
        <v-card-title>{{ $t('dashboard.totalEarned') }}</v-card-title>
        <v-layout
          v-for="(item, o) in portfolioDetails.data"
          :key="o"
          wrap
          class="mt-4 mb-5"
        >
          <v-flex
            xs7
            main-text
            pl-5
            pt-0
            pb-0
          >
            <span class="text-no-wrap">
              {{ item.base_currency | renderSymbol }}
              {{ item.total_earned | formatMoney }}
            </span>
          </v-flex>
          <v-flex
            xs5
            pt-0
            pb-0
          >
            <v-chip
              color="info text-black"
              small
            >
              <v-icon
                left
                :class="colorPnL(item.total_earned_ptc)"
              >
                {{ item.total_earned_ptc >=0 ? 'mdi-menu-up' : 'mdi-menu-down' }}
              </v-icon>
              {{ item.total_earned_ptc }}%
            </v-chip>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex
      v-if="!$apollo.loading && portfolioDetails"
      md6
      xs12
    >
      <v-card>
        <v-card-title>{{ $t('dashboard.myTraders') }}</v-card-title>
        <v-layout
          wrap
          class="mt-1 mb-3"
        >
          <v-flex
            xs12
            pl-5
            pt-3
            pb-0
          >
            <v-chip
              color="info text-black"
              small
            >
              {{ linkedAccounts }} {{ $t('dashboard.traders') }}
            </v-chip>
          </v-flex>
          <v-flex
            xs12
            pl-5
          >
            <v-btn
              outlined
              text
              small
              @click="$router.push('/rankings')"
            >
              {{ $t('dashboard.join') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
const PORTFOLIO_DETAILS_QUERY = require("@/graphql/queries/PortfolioDetails.gql");
import { mapGetters } from "vuex";

export default {
  name: "PortfolioTotalEarned",
  data() {
    return {};
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    linkedAccounts() {
      return this.getUser !== null ? this.getUser.count_connections : 0
    }
  },
  methods: {},
  apollo: {
    portfolioDetails: {
      query: PORTFOLIO_DETAILS_QUERY
    }
  }
};
</script>

<style lang="scss">
</style>
